<template>
	<div>
		<input 
            v-model="fallback"
            class="form-control"
            placeholder="Fallback"
            @input="dataChanged()"
        >

		<button class="btn btn-success" @click="saveFallback">
            Save
        </button>
	</div>
</template>

<script>
    import axios from 'axios';

	export default {
		data() {
            return {
                fallback: null,
                command_id: null,
                service_id: null
            }
        },
        methods: {
            saveFallback() {
				let data = this.$store.state.responseData;
				console.log(JSON.stringify(data));
				
                axios.post('/command_response/save/' + this.command_id, {
					record: data,
				})
				.then((response) => {
					this.$root.loader = false
					if (response.data.status == 1) {
						this.$root.notify({
							message: this.$t('successfully updated'),
							status: 'success',
							area: 'topRight',
						})
					}
				})
				.catch(() => {
					this.$root.loader = false
					this.$root.notify({
						message: this.$t('server error'),
						status: 'error',
						autoHide: true,
						area: 'topRight',
					})
				})
            },
            dataChanged() {
				if (this.$store.state.responseData) {
					this.$store.commit('setResponseDataProperty', {resp_fallback_msg: this.fallback})
				} else {
					this.$router.push(`/services/${this.service_id}/commands/${this.command_id}/result/type`)
				}
			}
        },
        mounted() {
            //
        },
        created() {
			console.log(this.$store.state);
			this.fallback = this.$store.state.responseData.resp_fallback_msg
			
			this.command_id = this.$route.params.command_id
			this.service_id = this.$route.params.service_id
		},
	}
</script>
